/**
 * Icônes de navigation SaaS — une icône distincte par rubrique (sidebar, onglets, CTA).
 */
import {
  Boxes,
  Handshake,
  Megaphone,
  LayoutDashboard,
  LayoutGrid,
  LayoutList,
  Mail,
  Receipt,
  Scale,
  Settings,
  Shield,
  ShieldCheck,
  ShoppingCart,
  Sparkles,
  Store,
  Tag,
  TrendingUp,
  Users,
  Wallet,
} from "lucide-react";

/** Tableau de bord membre — onglets « Activité marché ». */
export const MEMBER_DASH_TAB_ICONS = {
  overview: LayoutGrid,
  buys: ShoppingCart,
  sales: TrendingUp,
  annonces: LayoutList,
  suggestions: Sparkles,
  negotiations: Handshake,
  disputes: Scale,
  invoices: Receipt,
};

/** Liens globaux sidebar membre (hors onglets dashboard). */
export const MEMBER_GLOBAL_NAV_ICONS = {
  dashboard: LayoutDashboard,
  marketplace: Store,
  publish: Megaphone,
  account: Settings,
  admin: Shield,
};

/** Console admin — onglets sidebar. */
export const ADMIN_TAB_ICONS = {
  overview: LayoutDashboard,
  pending: ShieldCheck,
  diffusion: Megaphone,
  disputes: Scale,
  transactions: Wallet,
  contact: Mail,
  users: Users,
  produits: Boxes,
  secteurs: Tag,
};
